// extracted by mini-css-extract-plugin
export default {"container":"EditDetailOther_container__PRqpR","desciption":"EditDetailOther_desciption__7I7QM","delete_button":"EditDetailOther_delete_button__dYG94"};